<template>
  <div :class="hiddenClass">
    <header id="header_hea">
      <div v-if="showDownload" class="dowloadApp flex-row justify-between align-center">
        <div class="flex-row align-center">
          <van-icon class="icon" name="cross" @click="handleClose" />
          <img src="../assets/images/logo/logo.png" alt="">
        </div>
        <a :href="$store.state.home.app_download_link" class="btn pr-10">Baixar App</a>
      </div>
      <div class="headerBox flex-row justify-between">
        <div>
          <div class="menu_btn" @click="showLeftNavClick">
            <!-- <van-icon
              v-show="!$parent.show_left_nav"
              name="ascending"
              class="menu_icon"
            />
            <van-icon
              v-show="$parent.show_left_nav"
              name="descending"
              class="menu_icon"
            /> -->
            <svg data-v-9409f8b7="" xmlns="http://www.w3.org/2000/svg" width="80%" height="80%"
              viewBox="0 0 20.413 12.425" :class="[$parent.show_left_nav ? 'left-tar svg_icon' : 'svg_icon']"
              fill="currentColor">
              <path
                d="M5666.2,158.425a1.2,1.2,0,1,1,0-2.4h8a1.2,1.2,0,1,1,0,2.4Zm12.322-.522a1.2,1.2,0,0,1,0-1.7l2.793-2.794H5666.2a1.2,1.2,0,1,1,0-2.4h15.115l-2.793-2.794a1.2,1.2,0,1,1,1.7-1.7l4.841,4.841a1.2,1.2,0,0,1,0,1.7l-4.841,4.841a1.2,1.2,0,0,1-1.7,0Zm-12.322-9.5a1.2,1.2,0,1,1,0-2.4h8a1.2,1.2,0,1,1,0,2.4Z"
                transform="translate(-5665 -146)"></path>
            </svg>
          </div>
          <div class="top_title">
            <img src="../assets/images/logo/logo.png" class="logo" @click="$router.push('/')">
          </div>
        </div>
        <!-- <div id="pc_time" class="hidden-xs-only">
          <span>{{ formattedTime }}(UTC-03:00)</span>
  
        </div> -->
        <div>
          <!-- <div v-show="!$parent.user_balance" class="login-register">
            <div class="login-btn" @click="$parent.login()">
              Entrar
            </div>
            <div class="register-btn" @click="$parent.register()">
              Registro
            </div>
          </div> -->
          <div v-show="$parent.user_balance" class="user-balance">
            <!-- <div class="user_info hidden-xs-only" style="display: flex;">
              <img src="../assets/images/person/avt.png" id="hd_avt">
              <div style="margin: auto 0.2rem;">
                <div style="margin-bottom: .06rem;" @click="doCopy(data.id)">
                  <span>{{ data.id }}</span>
                  <img src="../assets/images/person/copy.png" style="width: 0.24rem;">
                </div>
                <div>{{ data.nickname }}</div>
              </div>
            </div> -->
            <div class="bnumber">
              <div class="top_balance">
                <img class="jinbi" src="../assets/images/common/a04.png">
                <div class="balance">
                  {{ data.money }}
                </div>

                <img class="refresh_btn" src="../assets/images/person/a03.png" @click="getUserInfoPerson()">
              </div>
              <!-- <van-popover
                theme="dark"
                trigger="click"
                :actions="actions"
                placement="bottom-start"
                @select="fundosAction"
              >
                <template #reference>
    
                </template>
</van-popover> -->
              <!-- <div class="fund_btn">
                <span @click="showRecharge">Depósito&nbsp;|&nbsp;</span>
                <i class="el-icon-caret-bottom fz3" @click="show" />
                <i class="el-icon-caret-top fz3" v-else />
               </div> -->
              <section v-if="showDeposit" class="header-deposit-list" @click="$router.push('withdraw')">
                <article>Saque</article>
              </section>
              <!-- <van-icon name="search" class="simg" @click="$router.push('subgame')" /> -->
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import Fetch from "../utils/fetch";
export default {
  name: "Header",
  props: {
    showDownload: Boolean
  },
  data() {
    return {
      shouldHide: true,
      data: {},
      show_left_nav: false,
      show_popover: false,
      showDeposit: false,
      actions: [
        // { text: "Depósito", icon: "add-o" },
        { text: "Saque", icon: "idcard" },
      ],
      currentDate: new Date(),
      interval: null,
    };
  },
  computed: {
    hiddenClass() {
      return {
        //true是隐藏 false是不隐藏
        "hidden-xs-only": this.shouldHide,
      };
    },
    showLeftNav() {
      return {
        "left-tar": this.show_left_nav,
      };
    },
    formattedTime() {
      return this.formatDate(this.currentDate);
    },
  },
  created() {
    this.$bus.$on("send2headshow", (bool) => {
      this.shouldHide = bool;
    });
    this.startTimer();
    this.getUserInfoPerson();
  },
  mounted() {
    var that = this;
    document.addEventListener("click", function (e) {
      if (e.target.className != "el-icon-caret-bottom fz3") {
        that.showDeposit = false;
      }
    });
    console.log(this.showDownload, '=this.$store.home')
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    showRecharge() {
      this.$parent.isShowRecharge = true;
      // this.$parent.isShowFt = false;
    },
    show(e) {
      this.showDeposit = !this.showDeposit;
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    getUserInfoPerson() {
      Fetch("/user/getUserInfoAPi2").then((r) => {
        //console.log(r);
        this.data.money = 0.0;
        this.data = r.data;
      });
    },
    startTimer() {
      this.interval = setInterval(() => {
        this.currentDate = new Date();
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.interval);
    },
    formatDate(date) {
      let brazilianDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60000 - 180 * 60000
      );
      return (
        brazilianDate.toLocaleDateString("pt-BR", {
          month: "2-digit",
          day: "2-digit",
        }) +
        " " +
        brazilianDate.toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    },
    showLeftNavClick() {
      this.$parent.show_left_nav = !this.$parent.show_left_nav;
    },
    fundosAction(act) {
      if (act.text === "Depósito") {
        this.$router.push("recharge");
      }
      if (act.text === "Saque") {
        this.$router.push("withdraw");
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/variables.less";
@headerHeight: 1.2rem;

/deep/ .el-icon-caret-bottom {
  color: #fff;
}

.flex-row {
  display: flex;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.align-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.pr-10 {
  padding-right: 10px;
}

.headerBox {
  padding: 10px;
}

.header-deposit-list {
  position: absolute;
  right: 0.21rem;
  top: 1rem;
  opacity: 1;
  min-height: 1.1rem;
  height: auto;
  border: 0.02rem solid @bodercolor;
  margin-right: 0.5rem;
  padding: 0.15rem 0;
  transition: top 0.1s, height 0.1s;
  border-radius: 0.1rem;
  text-align: center;
  overflow: hidden;
  background-color: @vipTextMoneyColor;

  article {
    padding: 0 0.19rem;
    line-height: 0.8rem;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #fff;
    margin: 0;
    min-width: 1.7rem;
    text-align: left;
  }
}

header {
  position: fixed;
  box-sizing: border-box;
  width: 100%;
  max-width: @maxWidth;
  top: 0;
  left: 50%;
  margin-left: calc(-50%);
  // padding: 0 2px;
  // height: @headerHeight;
  background: @nav-bg-color;
  //background-image: url("../assets/images/common/top_bg.jpg");
  // padding-right: 10px;
  z-index: 6;
}

.menu_btn {
  float: left;
  width: 0.66rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu_btn svg {
  fill: #00b2ff;
}

.menu_icon {
  font-size: 0.6rem !important;
  color: @textcolor1;
}

#pc_time {
  color: @textcolor1;
  display: flex;
  width: 5rem;
  flex-direction: column;
  font-size: 0.32rem;
  align-items: center;
  justify-content: center;
  justify-items: center;
  height: 100%;
  font-weight: 700;

  span {
    display: block;
    height: 50%;
    display: flex;
    align-items: center;
  }
}

.top_title {
  //text-align: center;
  // font-size: 24px;
  display: flex;
  height: 100%;
  float: left;
  align-items: center;
  justify-items: center;
  //margin-left: 0.1rem;
}

.leftPng {
  width: 0.5rem;
}

.left-tar {
  transform: rotate(180deg);
}

.logo {
  width: 3rem;
}

.login-register {
  // position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.login-btn {
  padding: 0.25rem 0.3rem;
  color: @primary-color;
  display: flex;
  align-items: center;
  border-radius: 0.15rem;
  background-color: @anttextcolor;
  font-size: 0.23rem;
  margin-right: 0.5rem;
  border: 1px solid @anttextcolor;
}

.register-btn {
  padding: 0.25rem 0.3rem;
  color: @anttextcolor;
  //background-color: @mainColor;
  border: 1px solid @anttextcolor;
  display: flex;
  align-items: center;
  border-radius: 0.15rem;
  margin-right: 0.2rem;
  font-size: 0.23rem;
}

.fund_btn {
  padding: 0.25rem 0.25rem;
  color: @primary-color;
  // border: 1px solid @anttextcolor;
  display: flex;
  align-items: center;
  border-radius: 0.15rem;
  margin-right: 0.2rem;
  font-size: 0.26rem;
  margin-left: 0.21rem;
  background: @ButtonColor;

  span {
    color: #fff !important;
  }
}

.simg {
  font-size: 0.5rem;
  margin-right: 0.1rem;
  color: @popupTextColor;
}

.svg_icon path {
  fill: @popupTextColor;
}

.top_balance {
  // height: 1rem;
  margin-top: 1px;
  padding: 0.1rem 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid @bodercolor;
  border-radius: 0.2rem;
}

.refresh_btn {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.1rem;
}

.jinbi {
  height: 0.32rem;
  margin-top: -0.05rem;
  margin-right: 0.1rem;
  margin-left: 0.1rem;
}

.user_info {
  color: @textcolor1;
  padding-right: 0.4rem;
  width: 3.2rem;
  font-size: 0.34rem;
}

#hd_avt {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
}

.bnumber {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.balance {
  color: #ecc15c;
  font-size: 0.32rem;
  font-weight: 700;
}

.user-balance {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  right: 0;
  top: 0;
}

.dowloadApp {
  width: 100%;
  border-bottom: 1px solid @anttextcolor;

  .icon {
    color: @anttextcolor;
    width: 12px;
    height: 12px;
    padding: 10px;

  }

  img {
    height: 35px;
  }

  .btn {
    padding: 3px 5px;
    color: @textcolor1;
    background-color: @third-color;
    border-radius: 4px;
    font-size: 10px;
    margin-right: 10px;
    line-height: 1.5;
  }
}
</style>